import React from "react";
import SectionSeprator from "../SectionSeprator/SectionSeprator";
import "./FaqQuestions.scss";
import "./Responsive.scss";

const FaqQuestions = (props) => {
  return (
    <div className="faqQuestion">
      <div className="desktop">
        <div className="faqContents">
          <SectionSeprator title={props.sectionTitle} />
          <div className="questionWrapper">
            {props.questions.map((item, index) => {
              return (
                <div className="questions" key={index}>
                  <div className="questionCategory">
                    <p className="categoryTitle">{item.title}</p>
                  </div>
                  <div className="questionBox">
                    {item.questions.map((question, index) => {
                      return (
                        <div key={index} className="questionItems" onClick={(e) => props.openQuestion(e)}>
                          <div className="header">
                            <p>{question.question}</p>
                          </div>
                          <div className="content">
                            <p>{question.answer}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FaqQuestions);
